// components/BackButton.jsx
import { useNavigate } from 'react-router-dom';

export default function BackButton({ label = 'Back' }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(-1)}
      className="inline-flex items-center gap-2 rounded-md border px-3 mb-2 text-[14px] py-1.5 text-sm hover:bg-gray-50"
      aria-label="Go back"
    >
      ← {label}
    </button>
  );
}
